export default "__VITE_ASSET__Csv$VqOE__"